/* eslint-disable @typescript-eslint/no-explicit-any */

import { ResizeBox } from "@/components/shared/resize-box";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { PencilIcon, Trash2Icon, TriangleIcon } from "lucide-react";
import { ReactTableCell } from "../react-table-cell/react-table-cell";
import { ReactTableHeader } from "@/components/shared/react-table-header";
import { Fragment } from "react/jsx-runtime";
import { useUserInfo } from "@/global-data/use-user-info";
export const ReactTable = ({
  tableHeader,
  onResize,
  table,
  onAction,
  listData,
  filter,
  setFilter,
  filterRequest,
  onMapUsingFilenameUpdate,
  sortingHandler,
  sortBy,
  orderBy,
}: any) => {
  const { activePermission } = useUserInfo();

  return (
    <Table style={{ borderCollapse: "collapse", width: "100%" }}>
      <TableHeader>
        <TableRow>
          <TableHead className="hidden">
            <input type="checkbox" />
          </TableHead>
          {tableHeader?.map((header: any, index: number) => {
            return (
              <Fragment key={header.accessorKey}>
                {header.accessorKey === "settings" ? (
                  <TableHead
                    style={
                      {
                        // width: header.width,
                        // minWidth: header.minWidth,
                        // maxWidth: header.maxWidth,
                      }
                    }
                    className={cn({ "pl-5": index === 0 })}
                  >
                    <ReactTableHeader
                      label={header.header}
                      key={header.accessorKey}
                      header={header.accessorKey}
                      table={listData}
                      setFilter={setFilter}
                      filter={filter}
                      filterRequest={filterRequest}
                    >
                      <div>
                        <div className="text-center border-b border-slate-300 pb-1 mb-1">
                          {header.header}
                        </div>
                        <div className="grid grid-cols-[145px_155px_85px_149px_155px_192px_192px_139px] text-center gap-1">
                          <div>Days after order date</div>
                          <div>Is equal to order date</div>
                          <div>Today date</div>
                          <div>Order date format</div>
                          <div>Delivery date format</div>
                          <div>Supported document types</div>
                          <div>Ignore keys</div>
                          <div>Branch only search</div>
                        </div>
                      </div>
                    </ReactTableHeader>
                  </TableHead>
                ) : (
                  <TableHead
                    style={{
                      width: header.width,
                      minWidth: header.minWidth,
                      maxWidth: header.maxWidth,
                    }}
                    className={cn({ "pl-5": index === 0 })}
                  >
                    <ResizeBox
                      width={header.width}
                      onResize={(props: any) =>
                        onResize({ size: props, key: header.accessorKey })
                      }
                    >
                      <ReactTableHeader
                        label={header.header}
                        key={header.accessorKey}
                        header={header.accessorKey}
                        table={listData}
                        setFilter={setFilter}
                        filter={filter}
                        filterRequest={filterRequest}
                      >
                        {header.accessorKey === "retailer_name" ? (
                          <span
                            onClick={() => sortingHandler(header.accessorKey)}
                            className="flex items-center gap-1 w-full"
                          >
                            {header.header}
                            <span>
                              {sortBy === header.accessorKey ? (
                                <TriangleIcon
                                  className={cn(orderBy ? "rotate-180" : "")}
                                  fill="#1f2937"
                                  stroke="#1f2937"
                                  size={8}
                                />
                              ) : (
                                <span>
                                  <TriangleIcon
                                    fill="#1f2937"
                                    stroke="#1f2937"
                                    size={8}
                                  />
                                  <TriangleIcon
                                    className={"rotate-180"}
                                    fill="#1f2937"
                                    stroke="#1f2937"
                                    size={8}
                                  />
                                </span>
                              )}
                            </span>
                          </span>
                        ) : (
                          header.header
                        )}
                      </ReactTableHeader>
                    </ResizeBox>
                  </TableHead>
                )}
              </Fragment>
            );
          })}
          <TableHead className="text-center sticky right-0 z-[2] w-auto pr-0">
            <div className="flex justify-end">
              <div className="w-[66px] md:w-[135px] text-left pl-[8px]">
                Actions
              </div>
            </div>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {table.map((row: any, rowIndex: number) => (
          <TableRow key={row.id + rowIndex}>
            <TableCell className="w-[30px] hidden">
              <input type="checkbox" />
            </TableCell>
            {row.data.map((cell: any, index: number) => {
              return (
                <Fragment key={cell.key + index}>
                  {cell.key === "settings" ? (
                    <TableCell
                      // width={cell.width}
                      className={cn({ "pl-3": index === 0 })}
                      isLineClampDisable={true}
                    >
                      <ReactTableCell
                        header={cell.key}
                        value={cell.value}
                        row={row.originData}
                        onMapUsingFilenameUpdate={onMapUsingFilenameUpdate}
                        activePermission={activePermission}
                      />
                    </TableCell>
                  ) : (
                    <TableCell
                      width={cell.width}
                      style={{
                        width: cell.width,
                      }}
                      className={cn({ "pl-3": index === 0 })}
                    >
                      <ReactTableCell
                        header={cell.key}
                        value={cell.value}
                        row={row.originData}
                        onMapUsingFilenameUpdate={onMapUsingFilenameUpdate}
                      />
                    </TableCell>
                  )}
                </Fragment>
              );
            })}
            <TableCell
              className="text-right sticky right-0 w-auto bg-white"
              nestedClassName="pr-0"
            >
              <div className="flex items-center justify-end z-[2] bg-white">
                <div className="flex items-center w-[66px] md:w-[135px]">
                  <TooltipProvider>
                    {activePermission?.update ? (
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <Button
                            variant={"ghost"}
                            size={"icon"}
                            className="text-primary"
                            onClick={() =>
                              onAction({ data: row.originData, action: "edit" })
                            }
                          >
                            <PencilIcon />
                          </Button>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p>Edit</p>
                          <TooltipArrow />
                        </TooltipContent>
                      </Tooltip>
                    ) : null}

                    {activePermission?.delete ? (
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <Button
                            variant={"ghost"}
                            size={"icon"}
                            className="text-primary"
                            onClick={() =>
                              onAction({
                                data: row.originData,
                                action: "delete",
                              })
                            }
                          >
                            <Trash2Icon />
                          </Button>
                        </TooltipTrigger>

                        <TooltipContent>
                          <p>Delete</p>
                          <TooltipArrow />
                        </TooltipContent>
                      </Tooltip>
                    ) : null}
                  </TooltipProvider>
                </div>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
